import api from "./api";

export const sliderService = {
  // Get all sliders
  getAllSliders: async () => {
    const response = await api.get(`/slider/getallslider`);
    return response.data;
  },

  // Add new slider
  addSlider: async (formData) => {
    const response = await api.post(`/slider/addslider`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  },

  // Update slider
  updateSlider: async (id, formData) => {
    const response = await api.put(`/slider/updateslider/${id}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  },
};

